import Navbar from "../../../components/Navbar";
import React from "react";
import Profile from "../../../components/profile/Profile";
import EnterpriseSidebar from "../../../components/sidebars/EnterpriseSidebar";

const EnterpriseProfilePage = () => {

  return (
      <div className="job-list">
        <Navbar />
        <div className="job-list-container">
          <EnterpriseSidebar />
          <div className="job-list-body">
            <Profile />
          </div>
        </div>
      </div>
  )

}

export default EnterpriseProfilePage;